

import Header from './components/header';
import Features from './components/features';
import Footer from './components/footer';


function App() {
  return (
    <>
      <Header />
      <Features />
      <Footer />
    </>
  );
}

export default App;
